import { getInteractionSubmitOfTab } from "./store";

export const surveyElements = {
  rating: {
    completeText: "Submit",
    showQuestionNumbers: "off",
    pages: [
      {
        elements: [
          {
            type: "rating",
            name: "rating",
            title: "rating",
            rateType: "labels",
          },
        ],
      },
    ],
  },
  radiogroup: {
    completeText: "Submit",
    showQuestionNumbers: "off",
    pages: [
      {
        elements: [
          {
            type: "radiogroup",
            name: "radiogroup",
            title: "radiogroup",
            choices: ["Item 1", "Item 2", "Item 3"],
            showOtherItem: true,
            showNoneItem: true,
          },
        ],
      },
    ],
  },
  dropdown: {
    completeText: "Submit",
    showQuestionNumbers: "off",
    pages: [
      {
        elements: [
          {
            type: "dropdown",
            name: "dropdown",
            title: "dropdown",
            choices: ["Item 1", "Item 2", "Item 3"],
            showOtherItem: false,
            showNoneItem: false,
          },
        ],
      },
    ],
  },
  checkbox: {
    completeText: "Submit",
    showQuestionNumbers: "off",
    pages: [
      {
        elements: [
          {
            type: "checkbox",
            name: "checkbox",
            title: "checkbox",
            choices: ["Item 1", "Item 2", "Item 3"],
            showOtherItem: true,
            showNoneItem: true,
          },
        ],
      },
    ],
  },
  comment: {
    completeText: "Submit",
    showQuestionNumbers: "off",
    pages: [
      {
        elements: [
          {
            type: "comment",
            name: "comment",
            title: "comment",
          },
        ],
      },
    ],
  },
  ranking: {
    completeText: "Submit",
    showQuestionNumbers: "off",
    pages: [
      {
        elements: [
          {
            type: "ranking",
            name: "ranking",
            title: "ranking",
            choices: ["ranking 1", "ranking 2", "ranking 3"],
          },
        ],
      },
    ],
  },
  file: {
    completeText: "Submit",
    showQuestionNumbers: "off",
    pages: [
      {
        elements: [
          {
            type: "file",
            name: "file",
            title: "file",
          },
        ],
      },
    ],
  },
  tagbox: {
    completeText: "Submit",
    showQuestionNumbers: "off",
    pages: [
      {
        elements: [
          {
            type: "tagbox",
            name: "tagbox",
            title: "tagbox",
            choices: ["Item 1", "Item 2", "Item 3"],
            showOtherItem: true,
            showNoneItem: true,
            showSelectAllItem: true,
          },
        ],
      },
    ],
  },
  boolean: {
    completeText: "Submit",
    showQuestionNumbers: "off",
    pages: [
      {
        elements: [
          {
            type: "boolean",
            name: "boolean",
            title: "boolean",
          },
        ],
      },
    ],
  },
  multipletext: {
    completeText: "Submit",
    showQuestionNumbers: "off",
    pages: [
      {
        elements: [
          {
            type: "multipletext",
            name: "multipletext",
            title: "multipletext",
            items: [
              {
                name: "text1",
              },
              {
                name: "text2",
              },
            ],
          },
        ],
      },
    ],
  },
  signaturepad: {
    completeText: "Submit",
    showQuestionNumbers: "off",
    pages: [
      {
        elements: [
          {
            type: "signaturepad",
            name: "signaturepad",
            title: "signaturepad",
          },
        ],
      },
    ],
  },
  // input start
  text: {
    completeText: "Submit",
    showQuestionNumbers: "off",
    pages: [
      {
        elements: [
          {
            type: "text",
            name: "text",
            title: "text",
            inputType: "text",
          },
        ],
      },
    ],
  },
  color: {
    completeText: "Submit",
    showQuestionNumbers: "off",
    pages: [
      {
        elements: [
          {
            type: "text",
            name: "color",
            title: "color",
            inputType: "color",
          },
        ],
      },
    ],
  },
  date: {
    completeText: "Submit",
    showQuestionNumbers: "off",
    pages: [
      {
        elements: [
          {
            type: "text",
            name: "date",
            title: "date",
            inputType: "date",
          },
        ],
      },
    ],
  },
  datetime: {
    completeText: "Submit",
    showQuestionNumbers: "off",
    pages: [
      {
        elements: [
          {
            type: "text",
            name: "datetime",
            title: "datetime",
            inputType: "datetime-local",
          },
        ],
      },
    ],
  },
  email: {
    completeText: "Submit",
    showQuestionNumbers: "off",
    pages: [
      {
        elements: [
          {
            type: "text",
            name: "email",
            title: "email",
            inputType: "email",
          },
        ],
      },
    ],
  },
  month: {
    completeText: "Submit",
    showQuestionNumbers: "off",
    pages: [
      {
        elements: [
          {
            type: "text",
            name: "month",
            title: "month",
            inputType: "month",
          },
        ],
      },
    ],
  },
  number: {
    completeText: "Submit",
    showQuestionNumbers: "off",
    pages: [
      {
        elements: [
          {
            type: "text",
            name: "number",
            title: "number",
            inputType: "number",
          },
        ],
      },
    ],
  },
  password: {
    completeText: "Submit",
    showQuestionNumbers: "off",
    pages: [
      {
        elements: [
          {
            type: "text",
            name: "password",
            title: "password",
            inputType: "password",
          },
        ],
      },
    ],
  },
  range: {
    completeText: "Submit",
    showQuestionNumbers: "off",
    pages: [
      {
        elements: [
          {
            type: "text",
            name: "range",
            title: "range",
            inputType: "range",
          },
        ],
      },
    ],
  },
  phone: {
    completeText: "Submit",
    showQuestionNumbers: "off",
    pages: [
      {
        elements: [
          {
            type: "text",
            name: "tel",
            title: "tel",
            inputType: "tel",
          },
        ],
      },
    ],
  },
  time: {
    completeText: "Submit",
    showQuestionNumbers: "off",
    pages: [
      {
        elements: [
          {
            type: "text",
            name: "time",
            title: "time",
            inputType: "time",
          },
        ],
      },
    ],
  },
  url: {
    completeText: "Submit",
    showQuestionNumbers: "off",
    pages: [
      {
        elements: [
          {
            type: "text",
            name: "url",
            title: "url",
            inputType: "url",
          },
        ],
      },
    ],
  },
  week: {
    completeText: "Submit",
    showQuestionNumbers: "off",
    pages: [
      {
        elements: [
          {
            type: "text",
            name: "week",
            title: "week",
            inputType: "week",
          },
        ],
      },
    ],
  },
  // input end
};

export const getInteractionBarIcon = (answered, numberOfQuetions) => {
  if (answered === 0) {
    //waiting
    return `<svg class="circle-check waiting" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M12.5003 25.9708C11.4123 25.7241 10.3674 25.3158 9.40027 24.7596M5.72398 21.3658C5.04211 20.3752 4.52423 19.2812 4.19023 18.1258M3.90527 13.1246C4.10527 11.9371 4.49027 10.8121 5.03027 9.78082L5.24152 9.39957M8.63397 5.72332C9.80354 4.9182 11.1156 4.34297 12.5002 4.02832M11.2502 14.9996L13.7502 17.4996L18.7502 12.4996" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.4426 25.9718C18.5306 25.725 19.5755 25.3168 20.5426 24.7606M24.2189 21.3668C24.9008 20.3762 25.4186 19.2821 25.7526 18.1268M26.0376 13.1255C25.8376 11.938 25.4526 10.813 24.9126 9.78179L24.7013 9.40054M21.3089 5.7243C20.1393 4.91917 18.8272 4.34394 17.4427 4.0293" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
  } else if (answered === numberOfQuetions) {
    //complete
    return `<svg class="circle-check complete" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M11.25 15L13.75 17.5L18.75 12.5M3.75 15C3.75 16.4774 4.04099 17.9403 4.60636 19.3052C5.17172 20.6701 6.00039 21.9103 7.04505 22.955C8.08971 23.9996 9.3299 24.8283 10.6948 25.3936C12.0597 25.959 13.5226 26.25 15 26.25C16.4774 26.25 17.9403 25.959 19.3052 25.3936C20.6701 24.8283 21.9103 23.9996 22.955 22.955C23.9996 21.9103 24.8283 20.6701 25.3936 19.3052C25.959 17.9403 26.25 16.4774 26.25 15C26.25 13.5226 25.959 12.0597 25.3936 10.6948C24.8283 9.3299 23.9996 8.08971 22.955 7.04505C21.9103 6.00039 20.6701 5.17172 19.3052 4.60636C17.9403 4.04099 16.4774 3.75 15 3.75C13.5226 3.75 12.0597 4.04099 10.6948 4.60636C9.3299 5.17172 8.08971 6.00039 7.04505 7.04505C6.00039 8.08971 5.17172 9.3299 4.60636 10.6948C4.04099 12.0597 3.75 13.5226 3.75 15Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
  } else {
    //progress
    return `<svg class="circle-check progress" xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 26 24" fill="none"><path d="M10.5003 22.9708C9.41228 22.7241 8.36736 22.3158 7.40027 21.7596M15.5002 1.02832C17.9854 1.59591 20.2043 2.99043 21.7936 4.98358C23.3828 6.97672 24.2483 9.45038 24.2483 11.9996C24.2483 14.5488 23.3828 17.0224 21.7936 19.0156C20.2043 21.0087 17.9854 22.4032 15.5002 22.9708M3.72398 18.3658C3.04211 17.3752 2.52423 16.2812 2.19023 15.1258M1.90527 10.1246C2.10527 8.93707 2.49027 7.81207 3.03027 6.78082L3.24152 6.39957M6.63397 2.72332C7.80354 1.9182 9.11562 1.34297 10.5002 1.02832M9.25024 11.9996L11.7502 14.4996L16.7502 9.49958" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
  }
};

export const buttonDisable = (
  answered,
  numberOfQuetions,
  onload,
  colIsIpResponseSubmitted
) => {
  if (
    document?.querySelector(".impactSurveyStatus")?.textContent?.trim() ===
    "Completed"
  ) {
    return "";
  } else {
    return colIsIpResponseSubmitted
      ? "disabled"
      : Number(answered) > 0
      ? ""
      : "disabled";
  }
};

export const getAnsersCount = (answer) => {
  if (
    document?.querySelector(".impactSurveyStatus")?.textContent?.trim() ===
    "Completed"
  ) {
    return answer + 1;
  } else {
    return answer;
  }
};

export const interactionBarTemplate = (answered, numberOfQuetions, changes) => {
  answered = getAnsersCount(answered) || 0;
  return (
    `<div class="interaction-bar INTERACTION_BANNER" id="INTERACTION_BANNER">
      <div class="content">
        <div class="text hide-on-scroll-mob">
          <div class="text-wrapper">Interactive Features</div>
         <p class="div">
            This page includes interactive features for you to explore. When you are finished, <span class="break-after">please</span>
            click submit to finalize your responses and notify our team.
          </p>
        </div>
        <div class="info">
          <div class="content-2">
            <div class="text-wrapper-2"><span class="answered">${answered}</span> of <span class="numberOfQuetions">${numberOfQuetions}</span> Complete</div>
            <div class="text-wrapper-3">Auto-Save: On</div>
            <div class="last-save-timestamp interaction-changes">${changes}</div>
          </div>
          <button class="int-submit-button interaction-complete-btn ${buttonDisable(
            answered,
            numberOfQuetions,
            true
          )}" data-components-SML-mode="large">
            <div class="text-wrapper-4">Submit</div><span class="interaction-svg-icon">` +
    getInteractionBarIcon(answered, numberOfQuetions) +
    `</span></button></div></div></div>`
  );
};

export const fetchText = (obj, val, type, data) => {
  if (type === "multistep") {
    let responseObj = {};
    Object.keys(val).forEach((key) => {
      let newQue = key.replace("question", "page");
      let title = obj?.pages.find((f) => f.name === newQue)?.elements[0]?.title;
      responseObj[title] = fetchText(
        obj?.pages.find((f) => f.name === newQue)?.elements[0],
        val[key],
        obj?.pages.find((f) => f.name === newQue)?.elements[0]?.type
      );
    });
    return responseObj;
  }
  if (type === "text" || type === "comment") {
    return val;
  }
  if (
    type === "radiogroup" ||
    type === "dropdown" ||
    type === "radiogroupWithoutText" ||
    type === "dropdownWithoutText"
  ) {
    return obj?.choices?.find((f) => f.value === val)?.text || val;
  }
  if (type === "checkbox" || type === "checkboxWithoutText") {
    return obj?.choices
      ?.filter((f) => val.includes(f.value))
      ?.map((m) => m.text)
      ?.join(", ");
  }
  if (type === "matrix") {
    let parentObj = {};
    Object.keys(val).forEach((key) => {
      let keyVal = obj?.rows?.find((f) => f.value === key)?.text || key;
      let valVal =
        obj?.columns?.find((f) => f.value === val[key])?.text || val[key];
      parentObj[keyVal] = valVal;
    });
    return parentObj;
  }
  if (type === "matrixdropdown") {
    let parentObj = {};
    Object.keys(val).forEach((key) => {
      let keyVal = obj?.rows?.find((f) => f.value === key)?.text || key;
      let valVal = val[key];
      let childObjects = {};
      Object.keys(valVal).forEach((k) => {
        let childObj = {};
        let childk = obj?.columns.find((f) => f.name === k).title || k;
        childObj[childk] =
          obj?.columns
            .find((f) => f.name === k)
            ?.choices?.find((f) => f.value === valVal[k])?.text || valVal[k];
        childObjects[childk] = childObj[childk];
      });
      parentObj[keyVal] = childObjects;
    });
    return parentObj;
  }
  if (type === "rating" || type === "ratingLabels") {
    return obj?.rateValues?.find((f) => f.value === val)?.text;
  }
  return val;
};
